import { createTranslations } from '@npco/common-utils-translations'

export const filtersListTranslations = createTranslations({
  dateRangeErrorMessage:
    'Exporting is only available for a maximum date range of 12 months. Check your filters and try again.',
  statusErrorMessage:
    'Only approved transactions can be exported. Check your filters and try again.',
})
